import { protectWithAccountPermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute, Navigate } from '@tanstack/react-router'
import { AppRoute } from 'appRoutes'
import { NO_WORKSPACE_ACCESS } from 'const'
import { BillingPage } from 'features/billing'
import { useCurrentSubscription } from 'features/subscription'
import { useUserContext } from 'hooks/api/context'
import { subscriptionsQueryOptions } from 'hooks/api/subscriptions'
import { canViewBillingPermission } from 'hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/settings/billing/')({
  component: BillingSettingsRouteComponent,
  validateSearch: (search: Record<string, unknown>): { migrated?: number } => ({
    migrated: search.migrated === undefined ? undefined : Number(search.migrated),
  }),
  loader: ({ context: { queryClient, buildRequest } }) => {
    queryClient.prefetchQuery(subscriptionsQueryOptions(buildRequest, ['usageQuota']))
  },
  head: () => ({
    meta: [
      {
        title: withCompanyName('Billing'),
      },
    ],
  }),
  beforeLoad: protectWithAccountPermissions(canViewBillingPermission),
})

function BillingSettingsRouteComponent() {
  const { data: userContext } = useUserContext()
  const { currentSubscriptionId } = useCurrentSubscription()
  const search = Route.useSearch()

  // New-model accounts bill per workspace and are served by the route-based per-workspace billing
  // page. Old-model accounts keep the account-level billing page here, unchanged.
  if (
    userContext?.workspaceBillingEnabled === true &&
    currentSubscriptionId != null &&
    currentSubscriptionId !== NO_WORKSPACE_ACCESS
  ) {
    return (
      <Navigate
        to={AppRoute.WorkspaceBilling}
        params={{ subscriptionId: currentSubscriptionId }}
        search={search}
        replace
      />
    )
  }

  return <BillingPage />
}
